<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="mensagem"
    item-value="id"
    label="Mensagem personalizada"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:selection="item">
      {{ labelSelected(item) }}
    </template>
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-chip
          class="mr-2"
          color="primary"
          label
        >
          {{ item.item.codigoInterno }}
        </v-chip>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.item.mensagem }}
          </v-list-item-title>
        </v-list-item-content>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import Vue from 'vue';
import MessageService from '@/api/message-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    labelSelected() {
      return item => `${item.item.codigoInterno} - ${Vue.filter('truncate')(item.item.mensagem, 90)}`;
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchItems(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      if (isSelected) {
        return;
      }

      const searchValue = (isSelected || !val) ? '' : val;

      this.loading = true;
      MessageService.getMessages({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `mensagem like '%${searchValue.toLowerCase()}%' or codigoInterno like '%${searchValue.toLowerCase()}%'`,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
  },
};
</script>
